import React from "react"
import { css } from "@emotion/core"
import linkResolver from "../utils/linkResolver"
import ContentDecoration from "./UI/ContentDecoration"
import RichText from "./UI/RichText"
import { Link } from "gatsby"
import DateLabel from "components/UI/DateLabel"
import t from "theme"

const QuestionFull = ({ questionData }) => {
    const company = questionData.companies ? questionData.companies[0] : null

    const linkUrl = linkResolver({ slug: questionData.slug, type: "question" })
    const questionBody = questionData.question.json
    const answerBody = questionData.answers ? questionData.answers[0].answer.json : null

    const headline = questionData.headline
    const sortTimestamp = questionData.sortTimestamp

    return (
        <div>
            <div
                css={css`
                    margin-bottom: ${t.space[6]};
                `}>
                <ContentDecoration type="QUESTION" company={company} />

                <h1
                    css={css`
                        padding-top: ${t.space[2]};
                        padding-bottom: ${t.space[2]};
                    `}>
                    <Link to={linkUrl}>{headline}</Link>
                </h1>

                <DateLabel date={sortTimestamp} />
            </div>

            <RichText body={questionBody} linkUrl={linkUrl} />
            {answerBody && (
                <div>
                    <div
                        css={css`
                            color: ${t.color.primary};
                            font-weight: ${t.font.weight.semibold};
                            padding-top: ${t.space[3]};
                            padding-bottom: ${t.space[3]};
                        `}>
                        ANSWER
                    </div>
                    <RichText body={answerBody} linkUrl={linkUrl} />
                </div>
            )}
        </div>
    )
}

export default QuestionFull
